import { _ as _extends } from './extends-3e8335ef.esm.js';
import React__default from 'react';
import { View } from 'react-native';

class HoverableView extends React__default.Component {
  constructor() {
    super(...arguments);
    this.setStyles = styles => {
      this.root.setNativeProps({
        style: styles
      });
    };
  }
  render() {
    const {
      onHover,
      style,
      ...passThrough
    } = this.props;
    return /*#__PURE__*/React__default.createElement(View, _extends({
      ref: component => {
        this.root = component;
      },
      onMouseEnter: () => this.setStyles(onHover),
      onMouseLeave: () => this.setStyles(style),
      style: style
    }, passThrough));
  }
}
HoverableView.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "setStyles",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "styles",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "HoverableView"
};

export { HoverableView as H };
